const HEART_LAYER_CLASS = "valentines-hearts-layer";

function getHeartLayer() {
  let layer = document.querySelector(`.${HEART_LAYER_CLASS}`);
  if (layer) {
    return layer;
  }

  layer = document.createElement("div");
  layer.classList.add(HEART_LAYER_CLASS);
  document.body.appendChild(layer);
  return layer;
}

function createHeart(layer) {
  const heart = document.createElement("div");
  const drift = Math.random() * 24 - 12;

  heart.classList.add("valentines-heart");
  heart.style.left = `${Math.random() * 100}vw`;
  heart.style.animationDuration = `${Math.random() * 2 + 3}s`;
  heart.style.setProperty("--heart-drift", `${drift}vw`);
  heart.textContent = "💗";

  layer.appendChild(heart);

  heart.addEventListener(
    "animationend",
    () => {
      heart.remove();
    },
    { once: true }
  );
}

const today = new Date();
const isValentinesDay = today.getMonth() === 1 && today.getDate() === 14;
const reduceMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

const isFrontPage =
  document.body.classList.contains("weissenstadt-front-page") ||
  document.body.classList.contains("home") ||
  document.body.classList.contains("front-page");

if (isFrontPage && isValentinesDay && !reduceMotion) {
  const layer = getHeartLayer();
  setInterval(() => createHeart(layer), 320);
}
